export default __webpack_public_path__ + "static/media/isa6.2c2244c3.jpg";